<ng-container *ngIf="alertData">
    <div class="pb-20">
        <fb-error-alert>
            <div errorTitle [innerHTML]="alertData.errorTitle"></div>
            <div errorMessage [innerHTML]="alertData.errorMessage"></div>
        </fb-error-alert>
    </div>
</ng-container>

<form *ngIf="canEditFiles === true">
    <button (click)="fileInput.value = ''; fileInput.click()" type="button" mat-raised-button>Seleziona file</button>
    <span class="ml-16">{{ descrizioneImportazione }}</span>
    <input hidden #fileInput type="file" [multiple]="multipleFileUpload" (change)="onFileSelected($event)" />
</form>

<!-- Elenco file da importare -->
<ng-container *ngIf="uploadedFiles.length > 0">
    <div
        class="files-list"
        [style.height]="uploadedFiles.length > fileOverflowLimit ? uploadedFiles.length * 60 + 'px' : 'auto'"
        [class.files-overflow]="uploadedFiles.length > fileOverflowLimit">
        <div *ngFor="let file of uploadedFiles" fxLayout="row" fxLayoutAlign="space-between center" class="elenco-files my-16">
            <div fxLayout="row" fxLayoutAlign="center center">
                <mat-icon color="accent">insert_drive_file</mat-icon>
                <div class="files__name" fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-between center">
                    <div showTooltipWhenEllipsisActive fxFlex="70" class="text-semibold text-truncate">{{ file?.name }}</div>
                    <span fxFlex fxLayout="row" fxLayoutAlign.xs="start none" fxLayoutAlign="end center">{{ formatBytes(file?.size) }}</span>
                </div>
            </div>
            <ng-container>
                <button *ngIf="canEditFiles === true" matTooltip="Elimina" (click)="onDeleteFile(file)" mat-icon-button>
                    <mat-icon>delete</mat-icon>
                </button>
                <button matTooltip="Scarica" (click)="onDownloadFile(file)" mat-icon-button>
                    <mat-icon>cloud_download</mat-icon>
                </button>
            </ng-container>
        </div>
    </div>

    <div class="text-semibold my-16" fxLayout="row" fxLayoutAlign="start center">
        <div>File caricati: {{ uploadedFiles.length }}</div>
        <div *ngIf="filesLimit">&nbsp;-&nbsp;Limite di caricamento file: {{ filesLimit }}</div>
    </div>

    <div *ngIf="showConfirmActionButton === true" fxLayout="row">
        <button class="ml-auto" [disabled]="confermaImportazioneDisabled" mat-raised-button color="accent" (click)="onConfermaUpload()">Conferma</button>
    </div>
</ng-container>
